module.exports = __webpack_public_path__ + "img/ce44a6c.jpg";